<template>
  <div id="commonPageBox" style="text-align: center;">
    <div class="body-pageBox clearBox">
      <!-- 上一页按钮 -->
      <img
        class="body-pageBox-btn"
        :class="{'disabled': currentPage==1}"
        src="~@/assets/images/notice/img_002.png"
        @click="prevPage"/>
      <!-- 页码 -->
      <div
        v-for="page in pages"
        :key="page"
        class="body-pageBox-li"
        :class="{ active: page === currentPage }"
        @click="changePage(page)">
        {{ page }}
      </div>
      <!-- 下一页按钮 -->
      <img
        class="body-pageBox-btn"
        :class="{'disabled': currentPage==pageCount}"
        src="~@/assets/images/notice/img_001.png"
        @click="nextPage"/>
    </div>

    <div class="body-pageBoxScreen clearBox">
      <!-- 上一页按钮 -->
      <img
        class="body-pageBoxScreen-btn"
        :class="{'disabled': currentPage==1}"
        src="~@/assets/images/notice/img_002.png"
        @click="prevPage"/>
      <!-- 页码 -->
      <div
        v-for="page in pages"
        :key="page"
        class="body-pageBoxScreen-li"
        :class="{ active: page === currentPage }"
        @click="changePage(page)">
        {{ page }}
      </div>
      <!-- 下一页按钮 -->
      <img
        class="body-pageBoxScreen-btn"
        :class="{'disabled': currentPage==pageCount}"
        src="~@/assets/images/notice/img_001.png"
        @click="nextPage"/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    total: {
      type: Number,
      required: true, // 总数据条数
    },
    pageSize: {
      type: Number,
      default: 10, // 每页条数
    },
    isCenter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentPage: 1, // 当前页码
    };
  },
  computed: {
    pageCount() {
      return Math.ceil(this.total / this.pageSize);
    },
    pages() {
      // 简单实现：显示全部页码，如有需要可做省略页码逻辑（...）
      return Array.from({ length: this.pageCount }, (_, i) => i + 1);
    },
  },
  methods: {
    changePage(page) {
      if (page !== this.currentPage) {
        this.currentPage = page;
        this.$emit("page-change", this.currentPage);
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.changePage(this.currentPage - 1);
      }
    },
    nextPage() {
      if (this.currentPage < this.pageCount) {
        this.changePage(this.currentPage + 1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.body-pageBox{
  display: block;
  width: 100%;
  padding: vw(20) 0 0 0;
  box-sizing: border-box;

  &-btn{
    float: left;
    width: vw(40);
    height: vw(40);
    margin: 0 vw(11) 0 0;
    cursor: pointer;

    &.disabled{
      opacity: 0.8;
      cursor: not-allowed;
    }
  }

  &-li{
    float: left;
    min-width: vw(40);
    padding: 0 vw(5);
    box-sizing: border-box;
    text-align: center;
    height: vw(40);
    line-height: vw(40);
    font-size: vw(22);
    color: #6B6B6B;
    background-color: #EEEEEE;
    margin: 0 vw(11) 0 0;
    cursor: pointer;

    &.active{
      color: #FFFFFF;
      background-color: #BBA16E;
    }

    &:hover{
      color: #FFFFFF;
      background-color: #BBA16E;
    }
  }
}

.body-pageBoxScreen{
  display: none;

  &-btn{
    float: left;
    width: vw(20);
    height: vw(20);
    margin: 0 vw(6) 0 0;
    cursor: pointer;

    &.disabled{
      opacity: 0.8;
      cursor: not-allowed;
    }
  }

  &-li{
    float: left;
    min-width: vw(20);
    padding: 0 vw(3);
    box-sizing: border-box;
    text-align: center;
    height: vw(20);
    line-height: vw(20);
    font-size: vw(12);
    color: #6B6B6B;
    background-color: #EEEEEE;
    margin: 0 vw(6) 0 0;
    cursor: pointer;

    &.active{
      color: #FFFFFF;
      background-color: #BBA16E;
    }

    &:hover{
      color: #FFFFFF;
      background-color: #BBA16E;
    }
  }

}


@media screen and (max-width: 1400px) {
  .body-pageBox{
    display: none !important;
  }

  .body-pageBoxScreen{
    display: inline-block !important;
  }
}
</style>
